async function polyfill() {
  if (typeof globalThis.onscrollend === 'undefined') {
    // @ts-expect-error: scrollyfills is not typed
    await import('scrollyfills');
  }
}

export default void polyfill();
